<section>
  <div class="login-container">
    <img
      class="w-100"
      src="/cms/sites/default/files/login-image-header_0.webp"
      alt=""
    />
    <div class="p-10 bg-light-neutral">
      <div *ngIf="page === 'login' && alertMessage" class="d-flex">
        <digital-platform-icon
          icon="info-circle-solid"
          color="secondary"
          [height]="12"
          [width]="12"
          class="me-4"
        ></digital-platform-icon>
        <p
          class="fs-12 fw-bold"
          [innerHTML]="'MR.ACCOUNT.LOGIN.ALERT_BANNER' | translate | safeHtml"
        ></p>
      </div>
      <h3 class="mb-7">{{ titleText }}</h3>
      <p>{{ descriptionText }}</p>
      <digital-platform-cta-button
        (click)="universalLoginAndSignup()"
        data-automation-id="button"
        btnType="primary"
        >{{ buttonText }}</digital-platform-cta-button
      >
    </div>
  </div>
</section>
